// Shared MUI sx style objects for the DYK module.

export const headerSx = {
  background: '#ffffff',
  borderRadius: '8px',
  p: 2,
  mb: 2,
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  border: '1px solid #e2e8f0',
};

export const cardSx = {
  background: '#ffffff',
  border: '1px solid #e2e8f0',
  borderRadius: '12px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
};

export const btnSx = {
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.813rem',
  borderRadius: '8px',
  px: 2,
  py: 0.875,
  boxShadow: 'none',
  '&:hover': { boxShadow: 'none' },
};
